export const UserType = {
    ADMIN : 0,
    FACILITATOR : 1,
    USER : 2,
  }

// export interface UserInterface {
//   id?: number;
//   fullName: string;
//   email: string;
//   password: string;
//   isFirstTimeLogin: boolean;
//   createdAt?: string;
//   updatedAt?: string;
//   userType: number;
// }
